<template>
  <div id="app" ref="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import url(https://fonts.googleapis.com/css?family=Lato:100,100italic,200,200italic,300,300italic,400,400italic,700,700italic,900,900italic&subset=latin,latin-ext);

  @font-face {
    font-family: "Gilroy-Black";
    src: url("~@/assets/fonts/Radomir Tinkov - Gilroy-Black.woff2") format("woff2");
  }

  @font-face {
    font-family: "Gilroy-Bold";
    src: url("~@/assets/fonts/Radomir Tinkov - Gilroy-Bold.woff2") format("woff2");
  }

  @font-face {
    font-family: "Gilroy-BoldItalic";
    src: url("~@/assets/fonts/Radomir Tinkov - Gilroy-BoldItalic.woff2") format("woff2");
  }

  @font-face {
    font-family: "Gilroy-ExtraBold";
    src: url("~@/assets/fonts/Radomir Tinkov - Gilroy-ExtraBold.woff2") format("woff2");
  }

  @font-face {
    font-family: "Gilroy-ExtraBoldItalic";
    src: url("~@/assets/fonts/Radomir Tinkov - Gilroy-ExtraBoldItalic.woff2") format("woff2");
  }

  @font-face {
    font-family: "Gilroy-Light";
    src: url("~@/assets/fonts/Radomir Tinkov - Gilroy-Light.woff2") format("woff2");
  }

  @font-face {
    font-family: "Gilroy";
    src: url("~@/assets/fonts/Radomir Tinkov - Gilroy-Regular.woff2") format("woff2");
  }

  #app {
    font-family: Lato, Gilroy, Gilroy-Bold, Gilroy-Light, Gilroy-Black, Gilroy-ExtraBoldItalic, Gilroy-ExtraBold, Gilroy-BoldItalic,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100vh;
    overflow-x: hidden;
  }

  .lato-light {
    font-family: Lato, sans-serif;
    font-weight: 300;
  }

  .lato-normal {
    font-family: Lato, sans-serif;
    font-weight: 400;
  }

  .lato-bold {
    font-family: Lato, sans-serif;
    font-weight: 700;
  }

  .lato-extra-bold {
    font-family: Lato, sans-serif;
    font-weight: 800;
  }

  #app{
    scroll-behavior: smooth;
  }
</style>
